// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5218) return "static/chunks/5218.ebd8d5b5b093c221.js";
	if (chunkId === 6941) return "static/chunks/6941.080f07a3359596de.js";
	if (chunkId === 7572) return "static/chunks/7572.9dd18afda8e85039.js";
	if (chunkId === 8035) return "static/chunks/8035.7f31cd023f35fdc2.js";
	if (chunkId === 416) return "static/chunks/416.5bc31f991e184dae.js";
	if (chunkId === 8360) return "static/chunks/8360.503d951d2d5660d0.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1179":"199fa575b023400b","1680":"20c1bef0e33c2f39","5032":"d7e8f8922caae5b6","5170":"bba5bbbc5cafd19b","5252":"03518d38400d8de3","6398":"bdacf4b4a683945a","7454":"e244d70f89a011b3"}[chunkId] + ".js";
};